<template>
  <div class="attendance-page w100 pl20 pr20 pt20 pb20">
    <div class="hr-wrap">
      <span>教师考勤</span>
    </div>
    <el-form :label-position="labelPosition" :model="formLabelAlign" class="pt20">
        <el-form-item>
          <el-col :span="7">
            <el-form-item label="考勤状态:" label-width="80px" >
              <el-input v-model="formLabelAlign.status"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-form-item label="签到方式:" label-width="80px" >
              <el-input v-model="formLabelAlign.type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-form-item label="签到时间:" label-width="120px">
              <el-input v-model="formLabelAlign.attendanceTime"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
    </el-form>
    <div class="hr-wrap">
      <span>学生考勤</span>
    </div>
    <div class="pt20">
      <div style="display: flex; justify-content: end">
        <el-input v-model="studentName" placeholder="请输入学生名称" style="width: 200px;" class="mr20"></el-input>
        <el-button type="primary" @click="initPage">查询</el-button>
      </div>
      <div>
        <ul class="table-header mt20">
          <li>
            <span>应到：</span>
            <span class="blue">{{formLabelAlign.totalNumber}}</span>
          </li>
          <li>
            <span>实到： </span>
            <span class="blue">{{formLabelAlign.actualNumber}}</span>
          </li>
          <li>
            <span>迟到： </span>
            <span class="red">{{formLabelAlign.lateNumber}}</span>
          </li>
          <li>
            <span>缺勤： </span>
            <span class="red">{{formLabelAlign.absentNumber}}</span>
          </li>
          <li>
            <span>请假： </span>
            <span class="red">{{formLabelAlign.sickNumber}}</span>
          </li>
        </ul>
      </div>
      <el-table
        ref="singleTable"
        :data="studentList"
        border
        highlight-current-row
        :cell-style="cellStyle"
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="60">
          <template slot-scope="scope">
              {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          property="name"
          label="学生姓名"
          width="260">
        </el-table-column>
        <el-table-column
          property="className"
          label="班级名称"
          width="360">
        </el-table-column>
        <el-table-column
          width="180"
          align="center"
          property="attendanceTime"
          label="签到时间">
        </el-table-column>
        <!-- <el-table-column
          property="name"
          label="异常标识"
          width="180">
        </el-table-column> -->
        <el-table-column
          property="status"
          label="签到状态"
          align="center"
          width="180">
          <template slot-scope="scope">
            {{statusFormat(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180">
          <template slot-scope="scope">
            <el-button type="text" class="yellow" size="small" @click="setStatus(scope.row,'4')">缺勤</el-button><span class="hr-gray"></span>
            <el-button type="text" class="red" size="small" @click="setStatus(scope.row,'2')">迟到</el-button><span class="hr-gray"></span>
            <el-button type="text" class="black" size="small" @click="setStatus(scope.row,'3')">早退</el-button>
          </template>
        </el-table-column>
      </el-table>
     
    </div>
     <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination background @size-change="changeSize"
              @current-change="changePage"
              :current-page="paramSearch.current"
              :page-sizes="pageSizes"
              :page-size="paramSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
        ></el-pagination>
      </div>
  </div>
</template>
<script>
  import * as api from '@/api/overseasChinese/overseasChinese'
  export default {
    props: {
      info: {
        type: Object,
        default () {
            return {};
        }
      },
    },
    data() {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          absentNumber: 0,
          actualNumber: 0,
          attendanceTime: null,
          lateNumber: 0,
          sickNumber: 0,
          status: 0,
          totalNumber: 0,
          type: "",
        },
        studentName: '',
        studentList: [],
        loading: false,
        searchObj: {
            userName: '',
        },
        pageSizes:[10, 20, 30, 50, 100],
        paramSearch:{
            current:1,
            size:10,
            courseName:''
        },
        total: 0,
      };
    },
    created() {
      this.getAttendance()
      this.getAttendancePage()
    },
    methods: {
      initPage() {
        this.getAttendancePage()
      },
      getAttendance() {
        // let {day, pkteachclassid, timeType, week, termid } = JSON.parse(this.$route.query.info)
        let {day, pkteachclassid, timeType, week, termid } = this.info

        api.selectAttendanceDetails({
          day, 
          pkteachclassid,
          semesterId: termid,
          timeType,
          week 
        }).then(res => {
          this.loading = false
          if(res.data.code == 0) {
            this.formLabelAlign = res.data.data;
            this.formLabelAlign.type=="1"?this.formLabelAlign.type="手工":this.formLabelAlign.type="扫码";
            switch(this.formLabelAlign.status){
              case "1":
              this.formLabelAlign.status= "正常";
              break;
              case "2":
              this.formLabelAlign.status=  "迟到";
              break;
              case "3":
              this.formLabelAlign.status=  "早退";
              break;
              case "4":
              this.formLabelAlign.status=  "缺席";
              break;
              case "5":
              this.formLabelAlign.status=  "补卡待审核";
              break;
              default:
              return "";
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
      },
      getAttendancePage() {
        // let {day, pkteachclassid, timeType, week, termid } = JSON.parse(this.$route.query.info)
        let {day, pkteachclassid, timeType, week, termid } = this.info
        api.selectPCAttendanceStuPage({
          current: this.paramSearch.current,
          size: this.paramSearch.size,
          name: this.studentName,
          day,
          pkteachclassid,
          semesterId: termid,
          timeType,
          week
        }).then(res => {
          this.loading = false
          if(res.data.code == 0) {
            this.studentList = res.data.data.records || []
            this.total = res.data.data.total
          }
        })
        .catch(() => {
          this.loading = false
        })
      },
      setStatus(item,status) {
        let curStatus = this.statusFormat(status)
         this.$confirm(`将${item.name}的签到状态设置为${curStatus}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            // let { day, knob,pkteachclassid,termid, timeType, week } = JSON.parse(this.$route.query.info)
            let { day, knob,pkteachclassid,termid, timeType, week } = this.info
            let { attendanceTime, className,name, id, userNumber } = item
            api.setClassOverviewPC({
              day,
              knob,
              pkteachclassid,
              student: {
                attendanceTime ,
                className,
                id,
                name,
                status: status,
                userNumber
              },
              termid,
              timeType,
              week
            }).then(({data}) => {
              if(data.code == 0) {
                this.getAttendancePage()
                this.$message.success(data.data);
              } else {
                this.$message.error(data.msg);
              }
            })
        }).catch(() => {
                   
        });
      },
       // 条数
      changeSize(value) {
          this.paramSearch.size=value;
          this.paramSearch.current=1;
          this.getAttendancePage();
      },
      // 翻页
      changePage(value) {
          this.paramSearch.current=value;
          this.getAttendancePage();
      },
      statusFormat(status) {
        switch(status) {
          case '1':
            return '正常'
          case '2':
            return '迟到'
          case '3':
            return '早退'
          case '4':
            return '缺勤'
          case '5':
            return '补卡待审核'
          default:
            return '';
        }
      },
      cellStyle( {row, columnIndex }) {
        if(row.status == '1' && columnIndex == 4) {
          return 'color: #8FA9F2'
        } else if(row.status == '2' && columnIndex == 4) {
          return 'color: #EC5F59'
        } else if(row.status == '3' && columnIndex == 4) {
          return 'color: #333'
        } else if(row.status == '4' && columnIndex == 4) {
          return 'color: #DBAC51'
        } 
      }
    },
  }
</script>
<style scoped lang="less">
::v-deep {
  // .el-table .cell {
  //   display: flex;
  //   align-items: center;
  // }
}
.attendance-page {
  width: 90%;
  margin: 0 auto;
  .hr-wrap {
    border-bottom: 1px solid #eeeeee;
    span {
      line-height: 34px;
      text-align: center;
      display: inline-block;
      color: #8FA9F2;
      width: 140px;
			height: 0;
			border-bottom: 34px solid #E3EAFB;
			border-right: 10px solid transparent;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
  .table-header {
    display: flex;
    height: 40px;
    line-height: 40px;
    background: #E3EAFB;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    li {
      flex: 1;
      margin-left: 40px;
    }
    .blue {
      color: #8FA9F2
    }
    .red {
      color: #EC5F59
    }
    .yellow {
      color: #DBAC51
    }
    .black {
      color: #333
    }
  }
  .hr-gray {
    display: inline-block;
    width: 1px;
    height: 12px;
    background: #DBDBDB;
    margin: -2px 5px;
  }
}
</style>